import React from "react";
import { Link } from "react-router-dom";
import { getTargetFromType } from "./useOpenLink";

const CustomLink = ({ to, type, link, children, ...props }) => {
    if (!to) return children;
    const target = getTargetFromType(type, link);

    return (
        <Link to={to} target={target} {...props}>
            {children}
        </Link>
    );
};

export default CustomLink;
